import { ProxyDictionaryItem } from '@/models/dictionary/proxy';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { IProxyDictionaryApi } from '@/types';

export const useProxyDictionary = defineStore('proxyDictionary', () => {
    const items = shallowRef<ProxyDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    function setData(data: IProxyDictionaryApi[]) {
        console.time('set-proxy-dictionary');
        items.value = data.map((item) => new ProxyDictionaryItem(item));
        console.timeEnd('set-proxy-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
